import { useMutation, useQueryClient } from '@tanstack/react-query';
import { proposalProjectApiConnect } from '../lib/api/proposalProjectApi.connect';
/**
 * Update a LCAT (Labor Category)
 */ export function useUpdateLCAT(projectId) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ lcatId, ...data })=>{
            // Forwarding `data` unchanged keeps field identity intact (no
            // description→notes misrouting, no silent drops of baseHourlyRate /
            // title / level / estimatedHours) and means the LCAT detail drawer save
            // button actually persists everything the user typed.
            await proposalProjectApiConnect.updateLCAT(projectId, lcatId, data);
        },
        onSuccess: ()=>{
            // LCAT row is the canonical source of truth for base hourly rate.
            // Invalidate both surfaces that read it: the LCATs list (LCAT tab,
            // stats panel) AND every pricing scenario for this project (rate
            // cards overlay the canonical rate at fetch time, so they must
            // refetch to see the edit).
            queryClient.invalidateQueries({
                queryKey: [
                    'lcats',
                    projectId
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'pricing',
                    projectId
                ]
            });
        }
    });
}
